/*global fabric*/

import faceConfig from './face-config';
import CircleSlider from 'circle-slider';
import Cookies from 'js-cookie';

function CasketDesign(container) {
    this.active_face = null;
    this.container = container;
    this.image_scale = null;
    this.dirty = false;
    this.current_view = null;
    this.submit_form_id = '#CasketSubmitForm_Form';
    this.preview_mode = false;

    this.faces = {
        lid: faceConfig.lid('Lid'),
        left: faceConfig.left('Left Side'),
        right: faceConfig.right('Right Side'),
        top: faceConfig.top('Top'),
        bottom: faceConfig.bottom('Bottom')
    };

    return this;
}


CasketDesign.prototype.init = function() {
    if (this.badBrowser()) {
        $(this.container).html(`
            <div class="container">
                <div class="alert alert-danger">
                    <strong>Incompatible Web Browser</strong>
                    <p>In order to use our casket design service, please switch to a modern web browser.</p>
                    <p>For the best experience on this website, we recommend <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>.</p>
                </div>
            </div>
        `);
        return;
    }

    this.bindMenu();
    this.bindButtons();
    this.changeView('preview', 'lid');

    if ($(this.container).data('preview')) {
        this.preview_mode = true;
        this.initPreview();
    }

    $(this.container).css('min-height', $(this.container).height());

    if (this.firstLoad()) $('#casket-design-instructions').modal('show');

    $('.copy-casket-url').on('click', function(e){
        e.preventDefault();
        let copy_text = document.getElementById("casket-preview-url");
        copy_text.select();
        document.execCommand('copy');
    });

};


CasketDesign.prototype.initPreview = function() {

    ['lid', 'left', 'right', 'top', 'bottom'].forEach((face) => {

        const image_element = $(`.casket-design-preview-images .casket-design-preview-image-${face}`);

        if (!image_element.length) return;

        if (face === 'left' || face === 'right') {
            $('.casket-design-preview-images').append(`<canvas id="casket-design-temp-canvas-${face}"></canvas>`);

            const canvas = new fabric.Canvas(`casket-design-temp-canvas-${face}`, {
                backgroundColor: '#fff',
                width: this.faces[face].save_dims.width,
                height: this.faces[face].save_dims.height
            });

            const image = image_element[0];

            const imgInstance = new fabric.Image(image, {
                hasBorders: false,
                hasControls: false
            });

            imgInstance.set({
                width: this.faces[face].save_dims.width,
                height: this.faces[face].save_dims.height,
                left: 0,
                top: 0
            });

            canvas.add(imgInstance);

            canvas.renderAll();

            const face_1_base64 = canvas.toDataURL({
                    format: 'png',
                    left: this.faces[face].save_dims_1.left - 18,
                    top: this.faces[face].save_dims_1.top - 100,
                    width: this.faces[face].save_dims_1.width,
                    height: this.faces[face].save_dims_1.height
                }),
                face_2_base64 = canvas.toDataURL({
                    format: 'png',
                    left: this.faces[face].save_dims_2.left - 18,
                    top: this.faces[face].save_dims_2.top - 100,
                    width: this.faces[face].save_dims_2.width,
                    height: this.faces[face].save_dims_2.height
                });


            $(`.casket-design-preview-${face}-1 img`).attr('src', face_1_base64);
            $(`.casket-design-preview-${face}-2 img`).attr('src', face_2_base64);
        } else {
            $(`.casket-design-preview-${face} img`).attr('src', image_element.attr('src'));
        }

    });
};


CasketDesign.prototype.changeView = function(view, face, img_url) {
    const self = this;

    switch(view) {
        case 'choose_image':
            $(self.container).find('.casket-design-loading').addClass('active');
            //remove data-id from stock_image
            $(`input[name="stock_image[${face}]"]`).removeAttr("data-id");

            $('.casket-design-choose-image-thumbnail').off('click').on('click', function(e){
                e.preventDefault();
                const img_url = $(this).data('img');
                //add data-id attribute if using a thumbnail
                $(`input[name="stock_image[${face}]"]`).attr("data-id",$(this).data('id'));

                let $file_element = $(`#casket-design-image-upload-${face}`).find('input[type="file"]');
                $file_element.replaceWith($file_element.val('').clone(true));
                self.changeView('edit', self.active_face, img_url);
            });

            $('.casket-design-image-upload').addClass('hidden');

            const $file_input = $(`#casket-design-image-upload-${face}`).find('input[type="file"]');
            const $file_clone = $file_input.clone()
                                    .attr('name', $file_input.attr('name').replace('original_image', 'original_image_clone'))
                                    .attr('id', $file_input.attr('id').replace('original_image', 'original_image_clone'));

            $file_input.addClass('hidden');
            $file_clone.insertAfter($file_input);
            $file_clone.val('');

            $(`#casket-design-image-upload-${face}`).removeClass('hidden').find('input[type="file"]').off('change').on('change', function(e){
                e.preventDefault();
                const reader = new FileReader();
                reader.onload = event => {
                    self.changeView('edit', self.active_face, event.target.result);
                    $file_input.remove();
                    $file_clone
                        .attr('name', $file_input.attr('name').replace('original_image_clone', 'original_image'))
                        .attr('id', $file_input.attr('id').replace('original_image_clone', 'original_image'));
                };
                reader.readAsDataURL(e.target.files[0]);
            });

            $(self.container).find('.casket-design-view').addClass('hidden');
            $(self.container).find('.casket-design-choose-image').removeClass('hidden');
            setTimeout(() => $(self.container).find('.casket-design-loading').removeClass('active'), 500);

            break;

        case 'edit':
            $(self.container).find('.casket-design-loading').addClass('active');
            $(self.container).find(`.casket-design-edit-image .casket-design-edit`).addClass('hidden');
            $(self.container).find(`.casket-design-edit-image .casket-design-edit[data-face="${face}"]`).removeClass('hidden');
            self.loadEditCanvas(face, img_url, function(){
                self.loadEditCanvas(face, img_url, function(){
                    setTimeout(() => $(self.container).find('.casket-design-loading').removeClass('active'), 500);
                });
                $(self.container).find('.casket-design-view').addClass('hidden');
                $(self.container).find('.casket-design-edit-image').removeClass('hidden');
                setTimeout(() => $(self.container).find('.casket-design-loading').removeClass('active'), 500);
            });
            break;

        case 'submit_form':
            self.updateFileInputPositions();
            $(self.container).find('.casket-design-loading').addClass('active');
            $(self.container).find('.casket-design-view').addClass('hidden');
            $(self.container).find('.casket-design-submit-design').removeClass('hidden');
            self.updateFileInputPositions();
            setTimeout(() => $(self.container).find('.casket-design-loading').removeClass('active'), 500);
            $(self.container).find('#CasketSubmitForm_Form').off('submit').on('submit', function(e){
                self.removePageUnload();

                const $button = $('#CasketDesignForm_Form_action_submit');
                const formValid = $(this)[0].checkValidity();

                if (!recaptchaComplete && formValid) {
                    grecaptcha.execute();
                    $(this).addClass('was-validated');

                }

                if (!recaptchaComplete || formValid === false) {
                    e.preventDefault();
                    grecaptcha.execute();
                    $(this).addClass('was-validated');
                }

                if (recaptchaComplete && formValid) {
                    $('.cancel-submit-button').addClass('disabled').on('click', function(e){ e.preventDefault(); });
                    $('.casket-design-upload-message').removeClass('d-none');
                    $button.data('original-text', $button.html());
                    $button.width($button.width());
                    $button.attr('disabled', true);
                    $button.html('<i class="fas fa-circle-notch fa-spin"></i>');
                }

            });
            break;

        default:
            if (self.current_view !== view) $(self.container).find('.casket-design-loading').addClass('active');
            self.setActiveFace(face);
            if (face === 'left' || face === 'right') {
                $('.casket-design-handle-visibility-container').removeClass('hidden');
                if ($('#casket-design-handle-visibility').is(':checked')) {
                    $(self.container).addClass('casket-design-show-handles');
                }
            } else {
                $('.casket-design-handle-visibility-container').addClass('hidden');
                $(self.container).removeClass('casket-design-show-handles');
            }
            // $('#casket-design-image-upload').val('');
            $('.casket-design-menu-link').removeClass('active');
            $(`.casket-design-menu-link[data-face='${face}']`).addClass('active');
            $('.casket-design-add-image').text(`Edit ${self.faces[face].label} Image`);
            $(self.container).find('.casket-design-view').addClass('hidden');
            $(self.container).find('.casket-design-main').removeClass('hidden');
            $(self.container).find('.casket-design-preview-box').attr('class', 'casket-design-preview-box').addClass(`casket-design-preview-show-${face}`);
            if (self.current_view !== view) setTimeout(() => $(self.container).find('.casket-design-loading').removeClass('active'), 500);
    }

    self.current_view = view;

};


CasketDesign.prototype.bindMenu = function() {
    const self = this;

    $(self.container).on('click', '[data-action="change-face"]', function(e){
        e.preventDefault();
        const face = $(this).data('face');
        self.changeView('preview', face);
    });
};


CasketDesign.prototype.setActiveFace = function(face) {
    this.active_face = face;
};

CasketDesign.prototype.resetFileInputPositions = function() {
    const self = this;
    $(`${self.submit_form_id} input[type="file"]`).each(function(){
        let face = $(this).attr('name').replace(/original_image\[([a-z]+)\]/, '$1');
        $(this).removeClass('hidden').prependTo(`#casket-design-image-upload-${face}`);
    });
};

CasketDesign.prototype.updateFileInputPositions = function() {
    const self = this;
    $(`.casket-design-image-upload`).each(function(){
        $(this).find('input[type="file"]').addClass('hidden').appendTo(self.submit_form_id);
    });
};


CasketDesign.prototype.bindButtons = function() {
    const self = this;

    $(self.container).on('click', '[data-action="toggle-handles"]', function(){
        $(self.container).toggleClass('casket-design-show-handles');
    });

    $(self.container).on('click', '[data-action="show-preview"]', function(e){
        e.preventDefault();
        if ($(this).parents('.casket-design-submit-design').length) self.resetFileInputPositions();
        self.changeView('preview', self.active_face);
    });

    $(self.container).on('click', '[data-action="choose-image"]', function(e){
        e.preventDefault();
        self.changeView('choose_image', self.active_face);
    });

    $(self.container).on('click', '[data-action="submit-design"]', function(e){
        e.preventDefault();
        self.changeView('submit_form');
    });
};


CasketDesign.prototype.canvasToImage = function(face) {

    const canvas = this.faces[face].canvas,
          { left, top, width, height } = this.faces[face].save_dims,
          base64 = canvas.toDataURL({
              format: 'png',
              left,
              top,
              width,
              height
          });

    $(`input[name="image[${face}]"]`).val(base64);
    //if using a stock image save id of image to value from data-id
    if($(`input[name="stock_image[${face}]"]`).attr("data-id")){
        let stock_image_id = $(`input[name="stock_image[${face}]"]`).attr("data-id");
        $(`input[name="stock_image[${face}]"]`).val(stock_image_id);
    }
    //empty out the data-id
    $(`input[name="stock_image[${face}]"]`).removeAttr("data-id");

    //if()
    //$(`input[name="stock_image[${face}]"]`).attr("data-id",$(this).data('id'));

    if (face === 'left' || face === 'right') {
        let face_1_base64 = canvas.toDataURL({
                format: 'png',
                left: this.faces[face].save_dims_1.left,
                top: this.faces[face].save_dims_1.top,
                width: this.faces[face].save_dims_1.width,
                height: this.faces[face].save_dims_1.height
            }),
            face_2_base64 = canvas.toDataURL({
                format: 'png',
                left: this.faces[face].save_dims_2.left,
                top: this.faces[face].save_dims_2.top,
                width: this.faces[face].save_dims_2.width,
                height: this.faces[face].save_dims_2.height
            });

        $(`.casket-design-preview-${face}-1 .casket-design-face`).attr('src', face_1_base64);
        $(`.casket-design-preview-${face}-2 .casket-design-face`).attr('src', face_2_base64);

        let handle_img = $(`.casket-design-preview-${face}-1 .casket-design-handle-1`).attr('src');
        let new_handle_img = handle_img.replace('caskethandle.png', 'caskethandle.png');
        $(`[class*='casket-design-preview-${face}-']`).find(`[class*='casket-design-handle-']`).attr('src', new_handle_img);

    } else {
        $(`.casket-design-preview-${face} .casket-design-face`).attr('src', base64);
    }
    return base64;

};


CasketDesign.prototype.loadEditCanvas = function(face, img_url, callback) {
    const self = this,
          img = new Image(),
          $container = $(`.casket-design-edit[data-face="${face}"]`),
          $text_container = $('.casket-design-text-control-container'),
          $text_colour_control = $('#casket-design-text-colour-control [name="casket-design-text-colour"]'),
          $text_font_control = $('#casket-design-text-font-control [name="casket-design-text-font"]'),
          $text_font_size_control = $('#casket-design-text-font-size-control [name="casket-design-text-font-size"]'),
          $text_control = $('#casket-design-text-control [name="casket-design-lid-text"]'),
          $text_control_val = $('#casket-design-text-control [name="casket-design-lid-text-val"]'),
          faceObj = self.faces[face];

    $container.html(`<canvas id="canvas-face-${face}" class="casket-design-edit-canvas"></canvas>`);

    const canvas = new fabric.Canvas(`canvas-face-${face}`, {
        backgroundColor: '#eee'
    });

    $text_colour_control.off('change');
    $text_font_control.off('change');
    $text_control.off('input');
    $text_control_val.off('change');

    canvas.setWidth(faceObj.canvas_dims.width);
    canvas.setHeight(faceObj.canvas_dims.height);
    canvas.preserveObjectStacking = true;
    canvas.controlsAboveOverlay = true;
    canvas.selection = false;
    img.onload = function() {

        let path,
            setImgWidth = 1400,
            imgWidth = img.width,
            imgHeight = img.height,
            ratio = 1;

        const imgInstance = new fabric.Image(img, {
            hasBorders: false,
            hasControls: false
        });

        if (imgWidth > setImgWidth || imgHeight > setImgWidth) {
            ratio = 1 / (imgWidth > imgHeight ? (imgWidth / setImgWidth) : (imgHeight / setImgWidth));
        }

        self.image_scale = ratio;

        imgInstance.set({
            width: imgWidth,
            height: imgHeight,
            scaleX: ratio,
            scaleY: ratio,
            originX: 'center',
            originY: 'center'
        });

        faceObj.image = imgInstance;

        if (faceObj.path_type === 'polygon') {
            let { top, left, scaleX, scaleY } = faceObj.path_dims;
            path = new fabric.Polygon(faceObj.path_points);
            path.set({
                top,
                left,
                scaleX,
                scaleY
            });
        } else {
            let { top, left, width, height } = faceObj.path_dims;
            path = new fabric.Rect({
                top,
                left,
                width,
                height
            });
        }

        canvas.clipPath = path;
        canvas.add(imgInstance);
        canvas.centerObject(imgInstance);

        if (face === 'lid') {

            $text_container.removeClass('hidden');

            const lid_text = new fabric.Textbox('', {
                left: 120,
                top: 192,
                width: 160,
                textAlign: 'center',
                breakWords: true,
                fill: '#ffffff',
                fontFamily: 'Arial',
                fontSize: 16,
                hasControls: false,
                lockMovementY: true,
                lockMovementX: true,
                editable: false,
                selectable: false
            });

            canvas.add(lid_text);
            lid_text.rotate(-90);
            canvas.bringToFront(lid_text);

            $text_control.on('input', function(e){
                e.preventDefault();
                const font_size = $text_font_size_control.val();
                let max_word_length = 15;

                if (font_size === 'large') max_word_length = 12;

                const words = $(this).val().split(' ');
                for (let w = 0; w < words.length; w++) {
                    const word_length = words[w].length;
                    if (word_length > max_word_length) {
                        let result = [],
                            i = 0;
                        while (i < word_length) {
                            result.push(words[w].substr(i, max_word_length));
                            i += max_word_length;
                        }
                        words[w] = result.join(' ');
                    }
                    words[w] = words[w].replace(/\n\s/g, '\n');
                }
                $text_control_val.val(words.join(' ')).trigger('change');
            });

            $text_control_val.on('change', function() {
                let val = $(this).val();
                lid_text.set('text', val);
                $(`input[name="LidText"]`).val(val);
                canvas.renderAll();
            }).change();

            $text_colour_control.on('change', function() {
                let val = $(this).val();
                let hex;
                switch (val) {
                    case 'black':
                        hex = '#000000';
                        break;
                    case 'red':
                        hex = '#a01818';
                        break;
                    case 'blue':
                        hex = '#2867e2';
                        break;
                    case 'yellow':
                        hex = '#ccbf1c';
                        break;
                    case 'green':
                        hex = '#208924';
                        break;
                    default:
                        hex = '#ffffff';
                        break;
                }
                lid_text.set('fill', hex);
                $(`input[name="LidTextColor"]`).val(val);
                canvas.renderAll();
            }).change();

            $text_font_control.on('change', function() {
                let font = $(this).val();
                lid_text.set('fontFamily', font);
                $(`input[name="LidTextFont"]`).val(font);
                canvas.renderAll();
            }).change();

            $text_font_size_control.on('change', function() {
                let val = $(this).val();
                let size, top;

                switch (val) {
                    case 'medium':
                        size = '20';
                        top = 282;
                        break;
                    case 'large':
                        size = '24';
                        top = 292;
                        break;
                    default:
                        size = '16';
                        top = 282;
                        break;
                }

                lid_text.set('fontSize', size);
                lid_text.set('top', top);

                canvas.renderAll();
            }).change();

        } else {
            $text_container.addClass('hidden');
        }

        canvas.renderAll();
        faceObj.canvas = canvas;
        self.createSliders(face);
        if (typeof callback === 'function') callback();

    };

    img.src = img_url;

    $('#casket-design-save-image').off('click').on('click', function(e){
        e.preventDefault();
        $(self.container).find('[data-action="submit-design"]').removeClass('disabled');
        self.canvasToImage(face);
        self.setPageUnload();
        self.changeView('preview', face);
    });

};

CasketDesign.prototype.createSliders = function(face) {
    const self = this,
          zoom_html = '<input type="range" min="0.3" max="2.2" step="0.1" value="1.0" id="casket-design-zoom-control" data-action="scale-image">',
          rotate_html = '<div id="casket-design-rotation-control"><div id="casket-design-rotation-angle"></div></div>';

    $('#casket-design-zoom-control').remove();
    $('#casket-design-rotation-control').remove();

    $('.casket-design-zoom-control-container').append(zoom_html);
    $('.casket-design-rotation-control-container').append(rotate_html);

    $('#casket-design-zoom-control').on('input', function(e){
        e.preventDefault();
        let scale = $(this).val();
        self.scaleImage(face, scale);
    });

    const cs = new CircleSlider('casket-design-rotation-control', {
        snap: 0,
        clockwise: true,
        startPos: 'left',
    });

    cs.on('sliderMove', (angle) => {
        self.rotateImage(face, angle);
    });

};

CasketDesign.prototype.rotateImage = function(face, angle) {
    const { canvas, image } = this.faces[face];
    if (image != null) image.rotate(angle);

    canvas.renderAll();
};

CasketDesign.prototype.scaleImage = function(face, scale) {
    const { canvas, image } = this.faces[face];

    image.set({
        scaleY: this.image_scale * scale,
        scaleX: this.image_scale * scale,
        originX: 'center',
        originY: 'center'
    });

    canvas.renderAll();
};

CasketDesign.prototype.setPageUnload = function() {
    if (!this.dirty) {
        window.onbeforeunload = function(e) {
            e.preventDefault();
            const dialogText = 'Do you really want to leave this site?';
            e.returnValue = dialogText;
            return dialogText;
        };
        this.dirty = true;
    }
};

CasketDesign.prototype.removePageUnload = function() {
    window.onbeforeunload = function() {
        return null;
    };
};

CasketDesign.prototype.badBrowser = function() {
    const ua = window.navigator.userAgent;
    return (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0);
};

CasketDesign.prototype.firstLoad = function() {
    if (typeof Cookies.get('casket-design-init') === 'undefined') {
        Cookies.set('casket-design-init', 1, { expires: 7 });
        return true;
    }
    return false;
};

module.exports = CasketDesign;
